import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { css } from "styled-components";

shareLinkStyles.wrapper = {
    css: css`
        margin-top: 27px;
        text-align: center;
        justify-content: flex-end;
        display: flex;
    `,
};

